import { setupWorker } from 'msw/browser'
import { http, HttpResponse } from 'msw'

// TODO
// Use typescript!
// 

function getRoundedDate() {
    let ms = 1000 * 60 * 10; // 10 minutes
    return new Date(Math.round(new Date().getTime() / ms) * ms);
}

const baseUrl = process.env.API_URL;

const policyResponse = {
    "safeZoneID": 0,
    "zoneTrafficLimitingPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": false,
            "threshold": 500000
        }
    ],
    "dnsQueryFloodPolicies": [
        {
            "enabled": true,
            "threshold": 2000,
            "server": "auth",
            "challenge": "passive",
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "dnsQueryFirstPacketPolicies": [
        {
            "enabled": false,
            "retransmissionStart": 1,
            "retransmissionStop": 4,
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "otherTrafficLimitingPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": false,
            "threshold": 100000
        }
    ],
    "otherNewConnLimitingPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": false,
            "threshold": 10000
        }
    ],
    "trafficLimitingForSingleIPPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": false,
            "threshold": 100000
        }
    ],
    "dstNewConnLimitingPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": false,
            "threshold": 30000
        }
    ],
    "tcpAbnormalPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": true,
            "threshold": 500
        }
    ],
    "tcpFinFloodPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": true,
            "threshold": 2000
        }
    ],
    "dnsSrcQueryLimitingPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": true,
            "threshold": 200
        }
    ],
    "dnsSrcReplyLimitingPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": false,
            "threshold": 200
        }
    ],
    "dnsReplyFloodPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": false,
            "threshold": 2000
        }
    ],
    "icmpTrafficLimitingPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": true,
            "threshold": 500
        }
    ],
    "quicFloodPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": false,
            "threshold": 2000
        }
    ],
    "quicMalformedPacketCheckPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": false
        }
    ],
    "quicSrcChallengeAuthPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": false
        }
    ],
    "tcpFragmentTrafficLimitingPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": true,
            "threshold": 1000
        }
    ],
    "tcpNewConnLimitingPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": false,
            "threshold": 10000
        }
    ],
    "tcpTrafficLimitingPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": false,
            "threshold": 200000
        }
    ],
    "tcpSynFloodPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": true,
            "threshold": 2000
        }
    ],
    "tcpSynFirstPacketCheckPolicies": [
        {
            "enabled": true,
            "retransmissionStart": 2,
            "retransmissionStop": 4,
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "synFloodSrcChallengeAuthPolicies": [
        {
            "enabled": true,
            "mode": "correct",
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "tcpSynAbnSrcLimitPolicies": [
        {
            "enabled": true,
            "synPackets": 20,
            "cycles": 3,
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "synFloodAbnormalSrcBlockPolicies": [
        {
            "enabled": true,
            "synRatioThreshold": 90,
            "packetCount": 20,
            "period": 3,
            "exceptions": 3,
            "exceptionsCheckTime": 5,
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "udpNewConnLimitingPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": true,
            "threshold": 10000
        }
    ],
    "udpTrafficLimitingPolicies": [
        {
            "strict": false,
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": true,
            "threshold": 50000
        }
    ],
    "tcpSynAckFloodPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": true,
            "threshold": 2000
        }
    ],
    "tcpSynAckFirstPacketCheckPolicies": [
        {
            "enabled": true,
            "retransmissionStart": 2,
            "retransmissionStop": 4,
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "tcpSynAckSrcChallengeModePolicies": [
        {
            "enabled": false,
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "tcpSynAckAbnormalSourceDetectionPolicies": [
        {
            "enabled": false,
            "numberOfAbnormalConnections": 1,
            "numberOfAbnormalConnectionsCycles": 5,
            "numberOfAbnormalSources": 3,
            "numberOfAbnormalSourcesCycles": 5,
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "tcpAckFirstPacketCheckPolicies": [
        {
            "enabled": true,
            "retransmissionStart": 0.1,
            "retransmissionStop": 1,
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "tckAckFloodAttackPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": true,
            "threshold": 20000
        }
    ],
    "tcpAckSessionBehaviorAnalysisPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": false,
            "threshold": 500
        }
    ],
    "tcpAckSessionDetectionModePolicies": [
        {
            "enabled": true,
            "mode": "loose",
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "tcpAbnAckConnDetectPolicies": [
        {
            "enabled": true,
            "packetLength": 1000,
            "proportion": 90,
            "packetsPerConnection": 15,
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "tcpAbnSynConnDetectPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": false,
            "threshold": 5
        }
    ],
    "tcpSrcAbnConnDropPolicies": [
        {
            "abnormalConnections": 3,
            "cycles": 5,
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "tcpConcurrentConnectionCheckByDestinationIPPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": true,
            "threshold": 20000
        }
    ],
    "tcpConnectionNumberCheckForSourceIPPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": true,
            "threshold": 200
        }
    ],
    "tcpNewConnectionRateCheckByDestinationIPPolicies": [
        {
            "threshold": 5000,
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "tcpNewConnectionRateCheckBySourceIPPolicies": [
        {
            "enabled": false,
            "threshold": 100,
            "cycles": 3,
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "tcpSrcNullConnDetectPolicies": [
        {
            "enabled": true,
            "packetsPerConnection": 3,
            "cycles": 5,
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "tcpSrcSockstressDetectPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": true,
            "threshold": 10
        }
    ],
    "tcpConnSourceBehaviorAnalysisDropPolicies": [
        {
            "abnormalConnections": 3,
            "cycles": 5,
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "httpAbnConnDefensePolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": true,
            "threshold": 2000
        }
    ],
    "httpMultiMethodConnDetectPolicies": [
        {
            "enabled": true,
            "abnormalConn": 3,
            "cycles": 5,
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "httpNullConnDetectPolicies": [
        {
            "enabled": true,
            "abnormalConn": 3,
            "cycles": 5,
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "httpRangeAmpDetectPolicies": [
        {
            "enabled": true,
            "abnormalConn": 3,
            "cycles": 5,
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "httpSlowLorisDetectPolicies": [
        {
            "enabled": false,
            "totalPacketLength": 10000,
            "payloadLength": 50,
            "thresholdAbnormalPackets": 10,
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "httpSrcAbnConnDetectPolicies": [
        {
            "enabled": true,
            "abnormalConnections": 3,
            "period": 5,
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "dstIpSignatureLearnRadioPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": true,
            "threshold": 20
        }
    ],
    "tlsAttackDstIpPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": true,
            "threshold": 20000
        }
    ],
    "tlsSrcChallengeAuthPolicies": [
        {
            "enabled": false,
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "tlsSuspiciousSrcChallengePolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": false,
            "threshold": 30
        }
    ],
    "tlsUnfixedResourceDetectPolicies": [
        {
            "enabled": false,
            "numberOfRequests": 300,
            "period": 5,
            "abnormalPeriods": 3,
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "tlsLargeResourceDetectPolicies": [
        {
            "enabled": true,
            "largeResource": 100,
            "percentageAbnormalSourceRequests": 80,
            "abnormalSourceRequests": 20,
            "period": 5,
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "tlsFixedResourceDetectPolicies": [
        {
            "enabled": true,
            "percentageAbnormalSourceRequests": 80,
            "abnormalSourceRequests": 15,
            "period": 5,
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "statisticsBasedOnDestinationIpPolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": true,
            "threshold": 5000
        }
    ],
    "httpSuspiciousSrcChallengePolicies": [
        {
            "deviceID": 1,
            "safeZoneID": 0,
            "enabled": false,
            "threshold": 50
        }
    ],
    "httpSourceAuthenicationDefensePolicies": [
        {
            "enabled": false,
            "mode": "javascript-redirect",
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "httpFirstPacketDropPolicies": [
        {
            "enabled": false,
            "retransmissionStart": 0,
            "retransmissionStop": 1,
            "deviceID": 1,
            "safeZoneID": 0
        }
    ],
    "httpFingerprintLearningPolicies": [
        {
            "enabled": true,
            "numberOfFingerprints": 50,
            "matchingPeriod": 5,
            "matchingFingerprintPeriods": 3,
            "deviceID": 1,
            "safeZoneID": 0
        }
    ]
};

// INITIAL VALUES
// 
const initial = {
    zones: [
        {
            "id": 0,
            "name": "DDoS Demo Zone",
            "description": "A demo zone",
            "createdAt": "2023-08-20T12:49:07+0000",
            "currentAttacks": 0,
            "currentState": "active",
            "ips": [
                "89.47.1.15\/32"
            ],
            "filters": [],
            "dropRate": 100,
            "geoRestrictions": [0,1,2],
            "allowList": [0,1],
            "denyList": [],
            "policy": {...policyResponse},
            "blockList": false,
        },
    ],
    filters: [
        {
            "id": 0,
            "name": "Drop all UDP",
            "protocol": "udp",
            "action": "drop\u0026denylist",
            "threshold": null,
            "settings": [],
        },
    ],
    subnets: [
        "89.47.1.15\/32",
    ],
    geoRestrictions: [
        {
            "location": "Other",
            "action": "pass",
            "threshold": null,
            "zoneId": 0,
        },
        {
            "location": "China",
            "action": "block",
            "threshold": null,
            "zoneId": 0,
        },
        {
            "location": "UnitedStates",
            "action": "limit",
            "threshold": 500,
            "zoneId": 0,
        },
    ],
    allowDenyList: [
        "81.172.220.193\/32",
        "1.1.1.1\/32",
    ],
};

let zones = [],
    filters = [],
    subnets = [],
    geoRestrictions = [],
    allowDenyList = [];

function initDemo() {
    // Read
    zones = localStorage.getItem('zones') ? JSON.parse(localStorage.getItem('zones')) : initial.zones;
    filters = localStorage.getItem('filters') ? JSON.parse(localStorage.getItem('filters')) : initial.filters;
    subnets = localStorage.getItem('subnets') ? JSON.parse(localStorage.getItem('subnets')) : initial.subnets;
    geoRestrictions = localStorage.getItem('geoRestrictions') ? JSON.parse(localStorage.getItem('geoRestrictions')) : initial.geoRestrictions;
    allowDenyList = localStorage.getItem('allowDenyList') ? JSON.parse(localStorage.getItem('allowDenyList')) : initial.allowDenyList;
    // Write
    localStorage.setItem('zones', JSON.stringify(zones));
    localStorage.setItem('filters', JSON.stringify(filters));
    localStorage.setItem('subnets', JSON.stringify(subnets));
    localStorage.setItem('geoRestrictions', JSON.stringify(geoRestrictions));
    localStorage.setItem('allowDenyList', JSON.stringify(allowDenyList));
}

initDemo();

const whoamiResponse = {
    "userid": 126,
    "require_2fa_setup": true,
    "has_2fa": false,
    "id": 126,
    "firstname": "Demo",
    "lastname": "User",
    "fullname": "Demo User",
    "companyname": "Demo Company",
    "email": "demo@company.com",
    "address1": "Demo Address",
    "city": "Demo City",
    "postcode": "Demo Postal Code",
    "countrycode": "NL",
    "country": "NL",
    "phonenumber": "612345678",
    "tax_id": "12345",
    "products": [
        {
            "key": "ddosv2",
            "name": "ddosv2",
            "description": "ddosv2"
        },
        {
            "key": "ddosv2_custom",
            "name": "ddosv2_custom",
            "description": "ddosv2_custom"
        },
    ],
    "admin": true,
    "admin_id": 126,
    "roles": [
        "ROLE_INTERNAL"
    ]
};
const zonesResponse = {
    "page": 1,
    "pageSize": 10,
    "total": zones.length,
    "items": zones,
};
const trafficResponse = {
    "1701127200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 2160),
        "flow": 164
    },
    "1701127800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 2150),
        "flow": 211
    },
    "1701128400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 2140),
        "flow": 162
    },
    "1701129000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 2130),
        "flow": 135
    },
    "1701129600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 2120),
        "flow": 277
    },
    "1701130200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 2110),
        "flow": 102
    },
    "1701130800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 2100),
        "flow": 104
    },
    "1701131400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 2090),
        "flow": 265
    },
    "1701132000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 2080),
        "flow": 93
    },
    "1701132600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 2070),
        "flow": 124
    },
    "1701133200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 2060),
        "flow": 84
    },
    "1701133800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 2050),
        "flow": 183
    },
    "1701134400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 2040),
        "flow": 170
    },
    "1701135000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 2030),
        "flow": 225
    },
    "1701135600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 2020),
        "flow": 156
    },
    "1701136200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 2010),
        "flow": 67
    },
    "1701136800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 2000),
        "flow": 289
    },
    "1701137400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1990),
        "flow": 89
    },
    "1701138000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1980),
        "flow": 79
    },
    "1701138600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1970),
        "flow": 163
    },
    "1701139200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1960),
        "flow": 96
    },
    "1701139800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1950),
        "flow": 87
    },
    "1701140400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1940),
        "flow": 179
    },
    "1701141000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1930),
        "flow": 61
    },
    "1701141600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1920),
        "flow": 91
    },
    "1701142200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1910),
        "flow": 153
    },
    "1701142800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1900),
        "flow": 69
    },
    "1701143400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1890),
        "flow": 86
    },
    "1701144000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1880),
        "flow": 221
    },
    "1701144600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1870),
        "flow": 97
    },
    "1701145200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1860),
        "flow": 73
    },
    "1701145800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1850),
        "flow": 225
    },
    "1701146400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1840),
        "flow": 65
    },
    "1701147000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1830),
        "flow": 70
    },
    "1701147600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1820),
        "flow": 283
    },
    "1701148200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1810),
        "flow": 123
    },
    "1701148800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1800),
        "flow": 93
    },
    "1701149400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1790),
        "flow": 214
    },
    "1701150000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1780),
        "flow": 100
    },
    "1701150600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1770),
        "flow": 162
    },
    "1701151200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1760),
        "flow": 87
    },
    "1701151800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1750),
        "flow": 127
    },
    "1701152400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1740),
        "flow": 112
    },
    "1701153000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1730),
        "flow": 226
    },
    "1701153600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1720),
        "flow": 88
    },
    "1701154200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1710),
        "flow": 184
    },
    "1701154800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1700),
        "flow": 250
    },
    "1701155400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1690),
        "flow": 122
    },
    "1701156000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1680),
        "flow": 102
    },
    "1701156600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1670),
        "flow": 314
    },
    "1701157200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1660),
        "flow": 127
    },
    "1701157800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1650),
        "flow": 101
    },
    "1701158400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1640),
        "flow": 214
    },
    "1701159000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1630),
        "flow": 97
    },
    "1701159600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1620),
        "flow": 154
    },
    "1701160200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1610),
        "flow": 244
    },
    "1701160800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1600),
        "flow": 139
    },
    "1701161400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1590),
        "flow": 159
    },
    "1701162000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1580),
        "flow": 258
    },
    "1701162600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1570),
        "flow": 103
    },
    "1701163200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1560),
        "flow": 135
    },
    "1701163800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1550),
        "flow": 400
    },
    "1701164400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1540),
        "flow": 194
    },
    "1701165000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1530),
        "flow": 101
    },
    "1701165600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1520),
        "flow": 304
    },
    "1701166200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1510),
        "flow": 128
    },
    "1701166800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1500),
        "flow": 120
    },
    "1701167400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1490),
        "flow": 232
    },
    "1701168000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1480),
        "flow": 155
    },
    "1701168600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1470),
        "flow": 194
    },
    "1701169200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1460),
        "flow": 142
    },
    "1701169800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1450),
        "flow": 146
    },
    "1701170400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1440),
        "flow": 158
    },
    "1701171000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1430),
        "flow": 312
    },
    "1701171600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1420),
        "flow": 143
    },
    "1701172200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1410),
        "flow": 112
    },
    "1701172800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1400),
        "flow": 341
    },
    "1701173400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1390),
        "flow": 163
    },
    "1701174000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1380),
        "flow": 187
    },
    "1701174600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1370),
        "flow": 158
    },
    "1701175200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1360),
        "flow": 195
    },
    "1701175800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1350),
        "flow": 126
    },
    "1701176400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1340),
        "flow": 304
    },
    "1701177000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1330),
        "flow": 189
    },
    "1701177600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1320),
        "flow": 226
    },
    "1701178200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1310),
        "flow": 129
    },
    "1701178800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1300),
        "flow": 203
    },
    "1701179400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1290),
        "flow": 152
    },
    "1701180000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1280),
        "flow": 303
    },
    "1701180600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1270),
        "flow": 133
    },
    "1701181200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1260),
        "flow": 112
    },
    "1701181800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1250),
        "flow": 284
    },
    "1701182400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1240),
        "flow": 102
    },
    "1701183000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1230),
        "flow": 102
    },
    "1701183600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1220),
        "flow": 220
    },
    "1701184200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1210),
        "flow": 93
    },
    "1701184800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1200),
        "flow": 80
    },
    "1701185400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1190),
        "flow": 260
    },
    "1701186000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1180),
        "flow": 118
    },
    "1701186600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1170),
        "flow": 120
    },
    "1701187200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1160),
        "flow": 269
    },
    "1701187800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1150),
        "flow": 108
    },
    "1701188400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1140),
        "flow": 110
    },
    "1701189000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1130),
        "flow": 212
    },
    "1701189600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1120),
        "flow": 112
    },
    "1701190200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1110),
        "flow": 105
    },
    "1701190800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1100),
        "flow": 198
    },
    "1701191400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1090),
        "flow": 117
    },
    "1701192000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1080),
        "flow": 103
    },
    "1701192600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1070),
        "flow": 227
    },
    "1701193200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1060),
        "flow": 130
    },
    "1701193800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1050),
        "flow": 89
    },
    "1701194400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1040),
        "flow": 254
    },
    "1701195000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1030),
        "flow": 113
    },
    "1701195600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1020),
        "flow": 72
    },
    "1701196200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1010),
        "flow": 325
    },
    "1701196800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 1000),
        "flow": 97
    },
    "1701197400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 990),
        "flow": 90
    },
    "1701198000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 980),
        "flow": 212
    },
    "1701198600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 970),
        "flow": 82
    },
    "1701199200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 960),
        "flow": 106
    },
    "1701199800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 950),
        "flow": 208
    },
    "1701200400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 940),
        "flow": 96
    },
    "1701201000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 930),
        "flow": 104
    },
    "1701201600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 920),
        "flow": 249
    },
    "1701202200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 910),
        "flow": 71
    },
    "1701202800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 900),
        "flow": 83
    },
    "1701203400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 890),
        "flow": 277
    },
    "1701204000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 880),
        "flow": 78
    },
    "1701204600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 870),
        "flow": 113
    },
    "1701205200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 860),
        "flow": 179
    },
    "1701205800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 850),
        "flow": 171
    },
    "1701206400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 840),
        "flow": 152
    },
    "1701207000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 830),
        "flow": 199
    },
    "1701207600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 820),
        "flow": 117
    },
    "1701208200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 810),
        "flow": 120
    },
    "1701208800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 800),
        "flow": 340,
        "drop": 57
    },
    "1701209400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 790),
        "flow": 196,
        "drop": 19
    },
    "1701210000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 780),
        "flow": 197
    },
    "1701210600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 770),
        "flow": 217
    },
    "1701211200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 760),
        "flow": 145
    },
    "1701211800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 750),
        "flow": 168
    },
    "1701212400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 740),
        "flow": 185
    },
    "1701213000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 730),
        "flow": 165
    },
    "1701213600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 720),
        "flow": 142
    },
    "1701214200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 710),
        "flow": 182
    },
    "1701214800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 700),
        "flow": 122
    },
    "1701215400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 690),
        "flow": 129
    },
    "1701216000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 680),
        "flow": 182
    },
    "1701216600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 670),
        "flow": 189
    },
    "1701217200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 660),
        "flow": 91
    },
    "1701217800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 650),
        "flow": 278
    },
    "1701218400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 640),
        "flow": 92
    },
    "1701219000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 630),
        "flow": 117
    },
    "1701219600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 620),
        "flow": 244
    },
    "1701220200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 610),
        "flow": 133
    },
    "1701220800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 600),
        "flow": 185
    },
    "1701221400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 590),
        "flow": 261
    },
    "1701222000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 580),
        "flow": 151
    },
    "1701222600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 570),
        "flow": 92
    },
    "1701223200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 560),
        "flow": 235
    },
    "1701223800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 550),
        "flow": 87
    },
    "1701224400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 540),
        "flow": 76
    },
    "1701225000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 530),
        "flow": 234
    },
    "1701225600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 520),
        "flow": 86
    },
    "1701226200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 510),
        "flow": 95
    },
    "1701226800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 500),
        "flow": 89
    },
    "1701227400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 490),
        "flow": 62
    },
    "1701228000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 480),
        "flow": 99
    },
    "1701228600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 470),
        "flow": 145
    },
    "1701229200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 460),
        "flow": 68
    },
    "1701229800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 450),
        "flow": 63
    },
    "1701230400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 440),
        "flow": 61
    },
    "1701231000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 430),
        "flow": 83
    },
    "1701231600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 420),
        "flow": 69
    },
    "1701232200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 410),
        "flow": 231
    },
    "1701232800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 400),
        "flow": 70
    },
    "1701233400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 390),
        "flow": 71
    },
    "1701234000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 380),
        "flow": 115
    },
    "1701234600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 370),
        "flow": 114
    },
    "1701235200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 360),
        "flow": 86
    },
    "1701235800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 350),
        "flow": 117
    },
    "1701236400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 340),
        "flow": 89
    },
    "1701237000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 330),
        "flow": 114
    },
    "1701237600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 320),
        "flow": 134
    },
    "1701238200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 310),
        "flow": 102
    },
    "1701238800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 300),
        "flow": 151
    },
    "1701239400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 290),
        "flow": 88
    },
    "1701240000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 280),
        "flow": 86
    },
    "1701240600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 270),
        "flow": 99
    },
    "1701241200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 260),
        "flow": 186
    },
    "1701241800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 250),
        "flow": 138
    },
    "1701242400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 240),
        "flow": 73
    },
    "1701243000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 230),
        "flow": 269
    },
    "1701243600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 220),
        "flow": 163
    },
    "1701244200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 210),
        "flow": 85
    },
    "1701244800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 200),
        "flow": 279
    },
    "1701245400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 190),
        "flow": 94
    },
    "1701246000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 180),
        "flow": 151
    },
    "1701246600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 170),
        "flow": 128
    },
    "1701247200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 160),
        "flow": 102
    },
    "1701247800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 150),
        "flow": 121
    },
    "1701248400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 140),
        "flow": 240
    },
    "1701249000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 130),
        "flow": 130
    },
    "1701249600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 120),
        "flow": 107
    },
    "1701250200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 110),
        "flow": 275
    },
    "1701250800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 100),
        "flow": 169
    },
    "1701251400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 90),
        "flow": 87
    },
    "1701252000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 80),
        "flow": 311
    },
    "1701252600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 70),
        "flow": 182
    },
    "1701253200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 60),
        "flow": 157
    },
    "1701253800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 50),
        "flow": 169
    },
    "1701254400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 40),
        "flow": 163
    },
    "1701255000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 30),
        "flow": 187
    },
    "1701255600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 20),
        "flow": 234
    },
    "1701256200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 10),
        "flow": 183
    },
    "1701256800": {
        "time": new Date(getRoundedDate()),
        "flow": 124
    }
};
const attacksResponse = {
    "page": 1,
    "pageSize": 25,
    "total": 0,
    "items": [],
};

// TODO
// Make sure we use current date
// 
const trafficTypesResponse = {
    // "1701132000": {
    //     "time": "2023-11-28T00:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 31,
    //     "http": 31,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 93,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701132600": {
    //     "time": "2023-11-28T00:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 57,
    //     "http": 57,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 124,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701133200": {
    //     "time": "2023-11-28T01:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 23,
    //     "http": 23,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 84,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701133800": {
    //     "time": "2023-11-28T01:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 119,
    //     "http": 119,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 183,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701134400": {
    //     "time": "2023-11-28T01:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 99,
    //     "http": 99,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 170,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701135000": {
    //     "time": "2023-11-28T01:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 160,
    //     "http": 160,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 225,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701135600": {
    //     "time": "2023-11-28T01:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 79,
    //     "http": 79,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 156,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701136200": {
    //     "time": "2023-11-28T01:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 8,
    //     "http": 8,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 67,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701136800": {
    //     "time": "2023-11-28T02:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 227,
    //     "http": 227,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 289,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701137400": {
    //     "time": "2023-11-28T02:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 22,
    //     "http": 22,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 89,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701138000": {
    //     "time": "2023-11-28T02:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 18,
    //     "http": 18,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 79,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701138600": {
    //     "time": "2023-11-28T02:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 98,
    //     "http": 98,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 163,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701139200": {
    //     "time": "2023-11-28T02:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 35,
    //     "http": 35,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 96,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701139800": {
    //     "time": "2023-11-28T02:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 27,
    //     "http": 27,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 87,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701140400": {
    //     "time": "2023-11-28T03:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 112,
    //     "http": 112,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 179,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701141000": {
    //     "time": "2023-11-28T03:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 0,
    //     "http": 0,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 61,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701141600": {
    //     "time": "2023-11-28T03:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 32,
    //     "http": 32,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 91,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701142200": {
    //     "time": "2023-11-28T03:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 93,
    //     "http": 93,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 153,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701142800": {
    //     "time": "2023-11-28T03:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 0,
    //     "http": 0,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 69,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701143400": {
    //     "time": "2023-11-28T03:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 0,
    //     "http": 0,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 86,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701144000": {
    //     "time": "2023-11-28T04:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 166,
    //     "http": 166,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 221,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701144600": {
    //     "time": "2023-11-28T04:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 31,
    //     "http": 31,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 97,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701145200": {
    //     "time": "2023-11-28T04:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 11,
    //     "http": 11,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 73,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701145800": {
    //     "time": "2023-11-28T04:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 165,
    //     "http": 165,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 225,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701146400": {
    //     "time": "2023-11-28T04:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 0,
    //     "http": 0,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 65,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701147000": {
    //     "time": "2023-11-28T04:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 1,
    //     "http": 1,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 70,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701147600": {
    //     "time": "2023-11-28T05:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 222,
    //     "http": 222,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 283,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701148200": {
    //     "time": "2023-11-28T05:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 57,
    //     "http": 57,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 123,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701148800": {
    //     "time": "2023-11-28T05:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 24,
    //     "http": 24,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 93,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701149400": {
    //     "time": "2023-11-28T05:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 147,
    //     "http": 147,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 214,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701150000": {
    //     "time": "2023-11-28T05:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 39,
    //     "http": 39,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 100,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701150600": {
    //     "time": "2023-11-28T05:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 87,
    //     "http": 87,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 162,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701151200": {
    //     "time": "2023-11-28T06:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 23,
    //     "http": 23,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 87,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701151800": {
    //     "time": "2023-11-28T06:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 57,
    //     "http": 57,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 127,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701152400": {
    //     "time": "2023-11-28T06:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 44,
    //     "http": 44,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 112,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701153000": {
    //     "time": "2023-11-28T06:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 158,
    //     "http": 158,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 226,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701153600": {
    //     "time": "2023-11-28T06:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 21,
    //     "http": 21,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 88,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701154200": {
    //     "time": "2023-11-28T06:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 107,
    //     "http": 107,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 184,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701154800": {
    //     "time": "2023-11-28T07:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 195,
    //     "http": 195,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 250,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701155400": {
    //     "time": "2023-11-28T07:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 45,
    //     "http": 45,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 122,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701156000": {
    //     "time": "2023-11-28T07:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 35,
    //     "http": 35,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 102,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701156600": {
    //     "time": "2023-11-28T07:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 252,
    //     "http": 252,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 314,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701157200": {
    //     "time": "2023-11-28T07:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 47,
    //     "http": 47,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 127,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701157800": {
    //     "time": "2023-11-28T07:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 29,
    //     "http": 29,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 101,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701158400": {
    //     "time": "2023-11-28T08:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 155,
    //     "http": 155,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 214,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701159000": {
    //     "time": "2023-11-28T08:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 27,
    //     "http": 27,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 97,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701159600": {
    //     "time": "2023-11-28T08:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 85,
    //     "http": 85,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 154,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701160200": {
    //     "time": "2023-11-28T08:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 175,
    //     "http": 175,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 244,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701160800": {
    //     "time": "2023-11-28T08:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 52,
    //     "http": 52,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 139,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701161400": {
    //     "time": "2023-11-28T08:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 68,
    //     "http": 68,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 159,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701162000": {
    //     "time": "2023-11-28T09:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 153,
    //     "http": 153,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 258,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701162600": {
    //     "time": "2023-11-28T09:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 37,
    //     "http": 37,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 103,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701163200": {
    //     "time": "2023-11-28T09:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 59,
    //     "http": 59,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 135,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701163800": {
    //     "time": "2023-11-28T09:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 92,
    //     "http": 92,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 400,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701164400": {
    //     "time": "2023-11-28T09:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 90,
    //     "http": 90,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 194,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701165000": {
    //     "time": "2023-11-28T09:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 37,
    //     "http": 37,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 101,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701165600": {
    //     "time": "2023-11-28T10:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 238,
    //     "http": 238,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 304,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701166200": {
    //     "time": "2023-11-28T10:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 57,
    //     "http": 57,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 128,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701166800": {
    //     "time": "2023-11-28T10:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 46,
    //     "http": 46,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 120,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701167400": {
    //     "time": "2023-11-28T10:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 152,
    //     "http": 152,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 232,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701168000": {
    //     "time": "2023-11-28T10:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 63,
    //     "http": 63,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 155,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701168600": {
    //     "time": "2023-11-28T10:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 126,
    //     "http": 126,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 194,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701169200": {
    //     "time": "2023-11-28T11:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 63,
    //     "http": 63,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 142,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701169800": {
    //     "time": "2023-11-28T11:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 84,
    //     "http": 84,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 146,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701170400": {
    //     "time": "2023-11-28T11:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 79,
    //     "http": 79,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 158,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701171000": {
    //     "time": "2023-11-28T11:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 249,
    //     "http": 249,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 312,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701171600": {
    //     "time": "2023-11-28T11:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 81,
    //     "http": 81,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 143,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701172200": {
    //     "time": "2023-11-28T11:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 49,
    //     "http": 49,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 112,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701172800": {
    //     "time": "2023-11-28T12:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 282,
    //     "http": 282,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 341,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701173400": {
    //     "time": "2023-11-28T12:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 90,
    //     "http": 90,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 163,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701174000": {
    //     "time": "2023-11-28T12:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 118,
    //     "http": 118,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 187,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701174600": {
    //     "time": "2023-11-28T12:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 83,
    //     "http": 83,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 158,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701175200": {
    //     "time": "2023-11-28T12:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 98,
    //     "http": 98,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 195,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701175800": {
    //     "time": "2023-11-28T12:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 53,
    //     "http": 53,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 126,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701176400": {
    //     "time": "2023-11-28T13:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 223,
    //     "http": 223,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 304,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701177000": {
    //     "time": "2023-11-28T13:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 87,
    //     "http": 87,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 189,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701177600": {
    //     "time": "2023-11-28T13:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 155,
    //     "http": 155,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 226,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701178200": {
    //     "time": "2023-11-28T13:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 66,
    //     "http": 66,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 129,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701178800": {
    //     "time": "2023-11-28T13:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 88,
    //     "http": 88,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 203,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701179400": {
    //     "time": "2023-11-28T13:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 83,
    //     "http": 83,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 152,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701180000": {
    //     "time": "2023-11-28T14:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 215,
    //     "http": 215,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 303,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701180600": {
    //     "time": "2023-11-28T14:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 45,
    //     "http": 45,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 133,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701181200": {
    //     "time": "2023-11-28T14:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 50,
    //     "http": 50,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 112,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701181800": {
    //     "time": "2023-11-28T14:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 224,
    //     "http": 224,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 284,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701182400": {
    //     "time": "2023-11-28T14:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 32,
    //     "http": 32,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 102,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701183000": {
    //     "time": "2023-11-28T14:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 35,
    //     "http": 35,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 102,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701183600": {
    //     "time": "2023-11-28T15:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 156,
    //     "http": 156,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 220,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701184200": {
    //     "time": "2023-11-28T15:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 30,
    //     "http": 30,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 93,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701184800": {
    //     "time": "2023-11-28T15:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 3,
    //     "http": 3,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 80,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701185400": {
    //     "time": "2023-11-28T15:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 193,
    //     "http": 193,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 260,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701186000": {
    //     "time": "2023-11-28T15:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 37,
    //     "http": 37,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 118,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701186600": {
    //     "time": "2023-11-28T15:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 41,
    //     "http": 41,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 120,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701187200": {
    //     "time": "2023-11-28T16:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 189,
    //     "http": 189,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 269,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701187800": {
    //     "time": "2023-11-28T16:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 44,
    //     "http": 44,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 108,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701188400": {
    //     "time": "2023-11-28T16:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 42,
    //     "http": 42,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 110,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701189000": {
    //     "time": "2023-11-28T16:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 137,
    //     "http": 137,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 212,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701189600": {
    //     "time": "2023-11-28T16:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 35,
    //     "http": 35,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 112,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701190200": {
    //     "time": "2023-11-28T16:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 24,
    //     "http": 24,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 105,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701190800": {
    //     "time": "2023-11-28T17:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 130,
    //     "http": 130,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 198,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701191400": {
    //     "time": "2023-11-28T17:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 41,
    //     "http": 41,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 117,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701192000": {
    //     "time": "2023-11-28T17:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 23,
    //     "http": 23,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 103,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701192600": {
    //     "time": "2023-11-28T17:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 142,
    //     "http": 142,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 227,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701193200": {
    //     "time": "2023-11-28T17:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 68,
    //     "http": 68,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 130,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701193800": {
    //     "time": "2023-11-28T17:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 25,
    //     "http": 25,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 89,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701194400": {
    //     "time": "2023-11-28T18:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 183,
    //     "http": 183,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 254,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701195000": {
    //     "time": "2023-11-28T18:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 33,
    //     "http": 33,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 113,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701195600": {
    //     "time": "2023-11-28T18:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 4,
    //     "http": 4,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 72,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701196200": {
    //     "time": "2023-11-28T18:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 251,
    //     "http": 251,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 325,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701196800": {
    //     "time": "2023-11-28T18:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 17,
    //     "http": 17,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 97,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701197400": {
    //     "time": "2023-11-28T18:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 20,
    //     "http": 20,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 90,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701198000": {
    //     "time": "2023-11-28T19:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 139,
    //     "http": 139,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 212,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701198600": {
    //     "time": "2023-11-28T19:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 8,
    //     "http": 8,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 82,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701199200": {
    //     "time": "2023-11-28T19:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 35,
    //     "http": 35,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 106,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701199800": {
    //     "time": "2023-11-28T19:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 129,
    //     "http": 129,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 208,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701200400": {
    //     "time": "2023-11-28T19:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 28,
    //     "http": 28,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 96,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701201000": {
    //     "time": "2023-11-28T19:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 30,
    //     "http": 30,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 104,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701201600": {
    //     "time": "2023-11-28T20:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 167,
    //     "http": 167,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 249,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701202200": {
    //     "time": "2023-11-28T20:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 10,
    //     "http": 10,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 71,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701202800": {
    //     "time": "2023-11-28T20:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 16,
    //     "http": 16,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 83,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701203400": {
    //     "time": "2023-11-28T20:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 205,
    //     "http": 205,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 277,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701204000": {
    //     "time": "2023-11-28T20:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 14,
    //     "http": 14,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 78,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701204600": {
    //     "time": "2023-11-28T20:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 44,
    //     "http": 44,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 113,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701205200": {
    //     "time": "2023-11-28T21:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 104,
    //     "http": 104,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 179,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701205800": {
    //     "time": "2023-11-28T21:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 90,
    //     "http": 90,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 171,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701206400": {
    //     "time": "2023-11-28T21:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 74,
    //     "http": 74,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 152,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701207000": {
    //     "time": "2023-11-28T21:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 124,
    //     "http": 124,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 199,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701207600": {
    //     "time": "2023-11-28T21:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 49,
    //     "http": 49,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 117,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701208200": {
    //     "time": "2023-11-28T21:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 51,
    //     "http": 51,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 120,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701208800": {
    //     "time": "2023-11-28T22:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 159,
    //     "http": 159,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 339,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701209400": {
    //     "time": "2023-11-28T22:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 94,
    //     "http": 94,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 196,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701210000": {
    //     "time": "2023-11-28T22:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 131,
    //     "http": 131,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 197,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701210600": {
    //     "time": "2023-11-28T22:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 126,
    //     "http": 126,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 217,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701211200": {
    //     "time": "2023-11-28T22:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 62,
    //     "http": 62,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 145,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701211800": {
    //     "time": "2023-11-28T22:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 102,
    //     "http": 102,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 168,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701212400": {
    //     "time": "2023-11-28T23:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 117,
    //     "http": 117,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 185,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701213000": {
    //     "time": "2023-11-28T23:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 88,
    //     "http": 88,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 165,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701213600": {
    //     "time": "2023-11-28T23:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 70,
    //     "http": 70,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 142,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701214200": {
    //     "time": "2023-11-28T23:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 122,
    //     "http": 122,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 182,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701214800": {
    //     "time": "2023-11-28T23:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 50,
    //     "http": 50,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 122,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701215400": {
    //     "time": "2023-11-28T23:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 56,
    //     "http": 56,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 129,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701216000": {
    //     "time": "2023-11-29T00:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 107,
    //     "http": 107,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 182,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701216600": {
    //     "time": "2023-11-29T00:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 79,
    //     "http": 79,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 189,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701217200": {
    //     "time": "2023-11-29T00:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 21,
    //     "http": 21,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 91,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701217800": {
    //     "time": "2023-11-29T00:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 206,
    //     "http": 206,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 278,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701218400": {
    //     "time": "2023-11-29T00:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 27,
    //     "http": 27,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 92,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701219000": {
    //     "time": "2023-11-29T00:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 51,
    //     "http": 51,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 117,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701219600": {
    //     "time": "2023-11-29T01:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 168,
    //     "http": 168,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 244,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701220200": {
    //     "time": "2023-11-29T01:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 67,
    //     "http": 67,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 133,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701220800": {
    //     "time": "2023-11-29T01:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 115,
    //     "http": 115,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 185,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701221400": {
    //     "time": "2023-11-29T01:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 189,
    //     "http": 189,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 261,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701222000": {
    //     "time": "2023-11-29T01:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 72,
    //     "http": 72,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 151,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701222600": {
    //     "time": "2023-11-29T01:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 22,
    //     "http": 22,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 92,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701223200": {
    //     "time": "2023-11-29T02:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 161,
    //     "http": 161,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 235,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701223800": {
    //     "time": "2023-11-29T02:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 20,
    //     "http": 20,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 87,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701224400": {
    //     "time": "2023-11-29T02:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 10,
    //     "http": 10,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 76,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701225000": {
    //     "time": "2023-11-29T02:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 167,
    //     "http": 167,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 234,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701225600": {
    //     "time": "2023-11-29T02:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 24,
    //     "http": 24,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 86,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701226200": {
    //     "time": "2023-11-29T02:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 32,
    //     "http": 32,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 95,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701226800": {
    //     "time": "2023-11-29T03:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 23,
    //     "http": 23,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 89,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701227400": {
    //     "time": "2023-11-29T03:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 0,
    //     "http": 0,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 62,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701228000": {
    //     "time": "2023-11-29T03:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 31,
    //     "http": 31,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 99,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701228600": {
    //     "time": "2023-11-29T03:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 78,
    //     "http": 78,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 145,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701229200": {
    //     "time": "2023-11-29T03:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 4,
    //     "http": 4,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 68,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701229800": {
    //     "time": "2023-11-29T03:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 0,
    //     "http": 0,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 63,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701230400": {
    //     "time": "2023-11-29T04:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 0,
    //     "http": 0,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 61,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701231000": {
    //     "time": "2023-11-29T04:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 22,
    //     "http": 22,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 83,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701231600": {
    //     "time": "2023-11-29T04:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 3,
    //     "http": 3,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 69,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701232200": {
    //     "time": "2023-11-29T04:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 153,
    //     "http": 153,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 231,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701232800": {
    //     "time": "2023-11-29T04:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 0,
    //     "http": 0,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 70,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701233400": {
    //     "time": "2023-11-29T04:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 3,
    //     "http": 3,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 71,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701234000": {
    //     "time": "2023-11-29T05:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 39,
    //     "http": 39,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 115,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701234600": {
    //     "time": "2023-11-29T05:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 42,
    //     "http": 42,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 114,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701235200": {
    //     "time": "2023-11-29T05:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 26,
    //     "http": 26,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 86,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701235800": {
    //     "time": "2023-11-29T05:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 48,
    //     "http": 48,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 117,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701236400": {
    //     "time": "2023-11-29T05:40:00+00:00",
    //     "dns_reply": 0,
    //     "https": 28,
    //     "http": 28,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 89,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701237000": {
    //     "time": "2023-11-29T05:50:00+00:00",
    //     "dns_reply": 0,
    //     "https": 56,
    //     "http": 56,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 114,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701237600": {
    //     "time": "2023-11-29T06:00:00+00:00",
    //     "dns_reply": 0,
    //     "https": 71,
    //     "http": 71,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 134,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701238200": {
    //     "time": "2023-11-29T06:10:00+00:00",
    //     "dns_reply": 0,
    //     "https": 30,
    //     "http": 30,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 102,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701238800": {
    //     "time": "2023-11-29T06:20:00+00:00",
    //     "dns_reply": 0,
    //     "https": 83,
    //     "http": 83,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 151,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    // "1701239400": {
    //     "time": "2023-11-29T06:30:00+00:00",
    //     "dns_reply": 0,
    //     "https": 17,
    //     "http": 17,
    //     "icmp": 0,
    //     "other": 0,
    //     "tcp_frag": 0,
    //     "tcp": 88,
    //     "udp_frag": 0,
    //     "udp": 0
    // },
    "1701240000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 360),
        "dns_reply": 0,
        "https": 21,
        "http": 21,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 86,
        "udp_frag": 0,
        "udp": 0
    },
    "1701240600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 350),
        "dns_reply": 0,
        "https": 36,
        "http": 36,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 99,
        "udp_frag": 0,
        "udp": 0
    },
    "1701241200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 340),
        "dns_reply": 0,
        "https": 115,
        "http": 115,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 186,
        "udp_frag": 0,
        "udp": 0
    },
    "1701241800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 330),
        "dns_reply": 0,
        "https": 60,
        "http": 60,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 138,
        "udp_frag": 0,
        "udp": 0
    },
    "1701242400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 320),
        "dns_reply": 0,
        "https": 18,
        "http": 18,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 73,
        "udp_frag": 0,
        "udp": 0
    },
    "1701243000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 310),
        "dns_reply": 0,
        "https": 193,
        "http": 193,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 269,
        "udp_frag": 0,
        "udp": 0
    },
    "1701243600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 300),
        "dns_reply": 0,
        "https": 93,
        "http": 93,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 163,
        "udp_frag": 0,
        "udp": 0
    },
    "1701244200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 290),
        "dns_reply": 0,
        "https": 18,
        "http": 18,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 85,
        "udp_frag": 0,
        "udp": 0
    },
    "1701244800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 280),
        "dns_reply": 0,
        "https": 203,
        "http": 203,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 279,
        "udp_frag": 0,
        "udp": 0
    },
    "1701245400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 270),
        "dns_reply": 0,
        "https": 36,
        "http": 36,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 94,
        "udp_frag": 0,
        "udp": 0
    },
    "1701246000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 260),
        "dns_reply": 0,
        "https": 87,
        "http": 87,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 151,
        "udp_frag": 0,
        "udp": 0
    },
    "1701246600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 250),
        "dns_reply": 0,
        "https": 55,
        "http": 55,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 128,
        "udp_frag": 0,
        "udp": 0
    },
    "1701247200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 240),
        "dns_reply": 0,
        "https": 34,
        "http": 34,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 102,
        "udp_frag": 0,
        "udp": 0
    },
    "1701247800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 230),
        "dns_reply": 0,
        "https": 32,
        "http": 32,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 121,
        "udp_frag": 0,
        "udp": 0
    },
    "1701248400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 220),
        "dns_reply": 0,
        "https": 172,
        "http": 172,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 240,
        "udp_frag": 0,
        "udp": 0
    },
    "1701249000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 210),
        "dns_reply": 0,
        "https": 57,
        "http": 57,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 130,
        "udp_frag": 0,
        "udp": 0
    },
    "1701249600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 200),
        "dns_reply": 0,
        "https": 39,
        "http": 39,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 107,
        "udp_frag": 0,
        "udp": 0
    },
    "1701250200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 190),
        "dns_reply": 0,
        "https": 197,
        "http": 197,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 275,
        "udp_frag": 0,
        "udp": 0
    },
    "1701250800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 180),
        "dns_reply": 0,
        "https": 94,
        "http": 94,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 169,
        "udp_frag": 0,
        "udp": 0
    },
    "1701251400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 170),
        "dns_reply": 0,
        "https": 25,
        "http": 25,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 87,
        "udp_frag": 0,
        "udp": 0
    },
    "1701252000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 160),
        "dns_reply": 0,
        "https": 227,
        "http": 227,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 311,
        "udp_frag": 0,
        "udp": 0
    },
    "1701252600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 150),
        "dns_reply": 0,
        "https": 118,
        "http": 118,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 182,
        "udp_frag": 0,
        "udp": 0
    },
    "1701253200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 140),
        "dns_reply": 0,
        "https": 49,
        "http": 49,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 157,
        "udp_frag": 0,
        "udp": 0
    },
    "1701253800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 130),
        "dns_reply": 0,
        "https": 95,
        "http": 95,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 169,
        "udp_frag": 0,
        "udp": 0
    },
    "1701254400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 120),
        "dns_reply": 0,
        "https": 89,
        "http": 89,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 163,
        "udp_frag": 0,
        "udp": 0
    },
    "1701255000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 110),
        "dns_reply": 0,
        "https": 117,
        "http": 117,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 187,
        "udp_frag": 0,
        "udp": 0
    },
    "1701255600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 100),
        "dns_reply": 0,
        "https": 161,
        "http": 161,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 234,
        "udp_frag": 0,
        "udp": 0
    },
    "1701256200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 90),
        "dns_reply": 0,
        "https": 113,
        "http": 113,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 183,
        "udp_frag": 0,
        "udp": 0
    },
    "1701256800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 80),
        "dns_reply": 0,
        "https": 60,
        "http": 60,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 124,
        "udp_frag": 0,
        "udp": 0
    },
    "1701257400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 70),
        "dns_reply": 0,
        "https": 287,
        "http": 287,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 372,
        "udp_frag": 0,
        "udp": 0
    },
    "1701258000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 60),
        "dns_reply": 0,
        "https": 67,
        "http": 67,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 139,
        "udp_frag": 0,
        "udp": 0
    },
    "1701258600": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 50),
        "dns_reply": 0,
        "https": 108,
        "http": 108,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 184,
        "udp_frag": 0,
        "udp": 0
    },
    "1701259200": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 40),
        "dns_reply": 0,
        "https": 136,
        "http": 136,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 208,
        "udp_frag": 0,
        "udp": 0
    },
    "1701259800": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 30),
        "dns_reply": 0,
        "https": 63,
        "http": 63,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 125,
        "udp_frag": 0,
        "udp": 0
    },
    "1701260400": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 20),
        "dns_reply": 0,
        "https": 112,
        "http": 112,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 175,
        "udp_frag": 0,
        "udp": 0
    },
    "1701261000": {
        "time": new Date(getRoundedDate() - 1000 * 60 * 10),
        "dns_reply": 0,
        "https": 164,
        "http": 164,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 250,
        "udp_frag": 0,
        "udp": 0
    },
    "1701261600": {
        "time": new Date(getRoundedDate()),
        "dns_reply": 0,
        "https": 67,
        "http": 67,
        "icmp": 0,
        "other": 0,
        "tcp_frag": 0,
        "tcp": 140,
        "udp_frag": 0,
        "udp": 0
    }
};
const limitsResponse = {
    "subnets": {
        "limit": 10,
        "current": subnets.length,
    },
    "dirtyTrafficGbps": {
        "limit": 0,
    },
    "dirtyTrafficMpps": {
        "limit": 0,
    },
    "asn": {
        "limit": 0,
    },
    "greTunnels": {
        "limit": 0,
    },
    "filters": {
        "limit": 10,
        "current": filters.length,
    },
    "allowDenySubnets": {
        "limit": 1,
        "current": 1,
    },
    "geoRestrictions": {
        "enabled": true,
    },
    "policySettings": {
        "enabled": false,
    },
    "zones": {
        "maxAmount": 10,
        "limit": 10,
        "current": zones.length,
    }
};
const filtersResponse = {
    "page": 1,
    "pageSize": 10,
    "total": filters.length,
    "items": filters,
};
const ddosv2Response = {
    "id": 3,
    "suspended": false,
    "settings": [
        {
            "slug": "basePrice",
            "valueType": "float",
            "value": 299.99,
            "description": "basePrice",
            "amount": 0,
            "maxAmount": 0
        },
        {
            "slug": "dirtyTrafficGbps",
            "valueType": "int",
            "value": 50,
            "description": "dirtyTrafficGbps",
            "amount": 0,
            "maxAmount": 0
        },
        {
            "slug": "dirtyTrafficMpps",
            "valueType": "int",
            "value": 50,
            "description": "dirtyTrafficMpps",
            "amount": 0,
            "maxAmount": 0
        },
        {
            "slug": "extraFeatures",
            "valueType": "block",
            "value": {
                "name": "DDoS v2 Extra Features",
                "slug": "ddosExtraFeatures",
                "description": "Extra Features Block",
                "price": "49.000",
                "settings": [
                    {
                        "name": "Allow/Deny List Subnets",
                        "slug": "allowDenySubnets",
                        "valueBool": null,
                        "valueDecimal": null,
                        "valueInteger": 50,
                        "valueFloat": null,
                        "valueString": null,
                        "valueDateTime": null
                    },
                    {
                        "name": "Geo Restrictions",
                        "slug": "geoRestrictions",
                        "valueBool": true,
                        "valueDecimal": null,
                        "valueInteger": null,
                        "valueFloat": null,
                        "valueString": null,
                        "valueDateTime": null
                    },
                    {
                        "name": "Policy Settings",
                        "slug": "policySettings",
                        "valueBool": true,
                        "valueDecimal": null,
                        "valueInteger": null,
                        "valueFloat": null,
                        "valueString": null,
                        "valueDateTime": null
                    },
                    {
                        "name": "Extra Filter",
                        "slug": "filters",
                        "valueBool": null,
                        "valueDecimal": null,
                        "valueInteger": 1,
                        "valueFloat": null,
                        "valueString": null,
                        "valueDateTime": null
                    }
                ]
            },
            "description": "extraFeatures",
            "amount": 0,
            "maxAmount": 0
        },
        {
            "slug": "extraZone",
            "valueType": "block",
            "value": {
                "name": "DDoS v2 Extra Zone",
                "slug": "ddosExtraZone",
                "description": "Extra Zone Block",
                "price": "49.000",
                "settings": [
                    {
                        "name": "Extra Zones",
                        "slug": "zones",
                        "valueBool": null,
                        "valueDecimal": null,
                        "valueInteger": 1,
                        "valueFloat": null,
                        "valueString": null,
                        "valueDateTime": null
                    },
                    {
                        "name": "Subnets",
                        "slug": "subnets",
                        "valueBool": null,
                        "valueDecimal": null,
                        "valueInteger": 1,
                        "valueFloat": null,
                        "valueString": null,
                        "valueDateTime": null
                    }
                ]
            },
            "description": "extraZone",
            "amount": 0,
            "maxAmount": 0
        },
        {
            "slug": "isTrial",
            "valueType": "bool",
            "value": false,
            "description": "asd",
            "amount": 0,
            "maxAmount": 0
        },
        {
            "slug": "remoteNetwork",
            "valueType": "block",
            "value": {
                "name": "DDoS v2 Remote Network",
                "slug": "ddosRemoteNetwork",
                "description": "Remote Network Block",
                "price": "249.000",
                "settings": [
                    {
                        "name": "ASN Amount",
                        "slug": "asn",
                        "valueBool": null,
                        "valueDecimal": null,
                        "valueInteger": 1,
                        "valueFloat": null,
                        "valueString": null,
                        "valueDateTime": null
                    },
                    {
                        "name": "Subnets",
                        "slug": "subnets",
                        "valueBool": null,
                        "valueDecimal": null,
                        "valueInteger": 8,
                        "valueFloat": null,
                        "valueString": null,
                        "valueDateTime": null
                    },
                    {
                        "name": "GRE Tunnels",
                        "slug": "greTunnels",
                        "valueBool": null,
                        "valueDecimal": null,
                        "valueInteger": 2,
                        "valueFloat": null,
                        "valueString": null,
                        "valueDateTime": null
                    },
                    {
                        "name": "Dirty Traffic Gbps",
                        "slug": "dirtyTrafficGbps",
                        "valueBool": null,
                        "valueDecimal": null,
                        "valueInteger": 500,
                        "valueFloat": null,
                        "valueString": null,
                        "valueDateTime": null
                    },
                    {
                        "name": "Dirty Traffic Mpps",
                        "slug": "dirtyTrafficMpps",
                        "valueBool": null,
                        "valueDecimal": null,
                        "valueInteger": 50,
                        "valueFloat": null,
                        "valueString": null,
                        "valueDateTime": null
                    }
                ]
            },
            "description": "remoteNetwork",
            "amount": 0,
            "maxAmount": 0
        },
        {
            "slug": "serveriusNetwork",
            "valueType": "block",
            "value": {
                "name": "DDoS v2 Serverius Network",
                "slug": "ddosServeriusNetwork",
                "description": "Serverius Network Block",
                "price": "199.000",
                "settings": [
                    {
                        "name": "Subnets",
                        "slug": "subnets",
                        "valueBool": null,
                        "valueDecimal": null,
                        "valueInteger": 8,
                        "valueFloat": null,
                        "valueString": null,
                        "valueDateTime": null
                    },
                    {
                        "name": "Dirty Traffic Gbps",
                        "slug": "dirtyTrafficGbps",
                        "valueBool": null,
                        "valueDecimal": null,
                        "valueInteger": 500,
                        "valueFloat": null,
                        "valueString": null,
                        "valueDateTime": null
                    },
                    {
                        "name": "Dirty Traffic Mpps",
                        "slug": "dirtyTrafficMpps",
                        "valueBool": null,
                        "valueDecimal": null,
                        "valueInteger": 50,
                        "valueFloat": null,
                        "valueString": null,
                        "valueDateTime": null
                    }
                ]
            },
            "description": "serveriusNetwork",
            "amount": 0,
            "maxAmount": 0
        },
        {
            "slug": "subnets",
            "valueType": "int",
            "value": 1,
            "description": "subnets",
            "amount": 0,
            "maxAmount": 0
        },
        {
            "slug": "zones",
            "valueType": "int",
            "value": 1,
            "description": "zones",
            "amount": 0,
            "maxAmount": 0
        },
        {
            "slug": "greTunnels",
            "valueType": "int",
            "value": 1,
            "description": "greTunnels",
            "amount": 0,
            "maxAmount": 0
        }
    ]
};
const templatesResponse = {
    "templates": [
        "Default Protection",
        "Strict Protection",
        "Loose Protection",
        "Game Server Loose",
        "Game Server Strict",
        "Web Server",
        "DNS Authorization Server",
        "DNS Cache Server"
    ]
};
const locationsResponse = {
    "locations": [
        // "OtherLocation",
        // "unknown-zone",
        "China",
        "BeiJing",
        "ShangHai",
        "TianJin",
        "ChongQing",
        "HongKong",
        "Macao",
        "HeBei",
        "ShanXi",
        "NeiMengGu",
        "LiaoNing",
        "JiLin",
        "HeiLongJiang",
        "JiangSu",
        "ZheJiang",
        "AnHui",
        "FuJian",
        "JiangXi",
        "ShanDong",
        "HeNan",
        "HuBei",
        "HuNan",
        "GuangDong",
        "GuangXi",
        "HaiNan",
        "SiChuan",
        "GuiZhou",
        "YunNan",
        "XiZang",
        "ShaanXi",
        "GanSu",
        "QingHai",
        "NingXia",
        "XinJiang",
        "TaiWan",
        "Andorra",
        "UnitedArabEmirate",
        "Afghanistan",
        "AntiguaandBarbuda",
        "Albania",
        "Armenia",
        "NetherlandsAntille",
        "Angola",
        "Anguilla",
        "Argentina",
        "AmericanSamoa",
        "Austria",
        "Australia",
        "Aruba",
        "AlandIslands",
        "Azerbaijan",
        "BosniaandHerz",
        "Barbados",
        "Bangladesh",
        "Belgium",
        "BurkinaFaso",
        "Bulgaria",
        "Bahrain",
        "Burundi",
        "Benin",
        "BermudaIsands",
        "BruneiDarussalam",
        "Bolivia",
        "Brazil",
        "Bahamas",
        "Bhutan",
        "BouvetIsland",
        "Botswana",
        "Belarus",
        "Belize",
        "Canada",
        "DemocraticRepublicoftheCongo",
        "CentralAfricanRepublic",
        "RepublicoftheCongo",
        "Switzerland",
        "CoteD\u0027Ivoire",
        "CookIslands",
        "Chile",
        "Cameroon",
        "Colombia",
        "CostaRica",
        "Cuba",
        "CapeVerde",
        "Cyprus",
        "CzechRepublic",
        "Germany",
        "Djibouti",
        "Denmark",
        "Dominica",
        "DominicanRepublic",
        "Algeria",
        "Ecuador",
        "Estonia",
        "Egypt",
        "WesternSahara",
        "Eritrea",
        "Spain",
        "Ethiopia",
        "Finland",
        "Fiji",
        "Falkland",
        "FederatedStatesofMicronesia",
        "FaroeIslands",
        "France",
        "Gabon",
        "UnitedKingdom",
        "Grenada",
        "Georgia",
        "FrenchGuiana",
        "Guernsey",
        "Ghana",
        "Gibraltar",
        "Greenland",
        "Gambia",
        "Guinea",
        "Guadeloupe",
        "EquatorialGuinea",
        "Greece",
        "SouthGeorgiaandtheSouthSandwichIslands",
        "Guatemala",
        "Guam",
        "BissauGuinea",
        "Guyana",
        "HeardIslandandMcDonaldIslands",
        "Honduras",
        "Croatia",
        "Haiti",
        "Hungary",
        "Indonesia",
        "Ireland",
        "Israel",
        "IsleofMan",
        "India",
        "BritishIndianOceanTerritory",
        "Iraq",
        "IslamicRepublicofIran",
        "Iceland",
        "Italy",
        "Jersey",
        "Jamaica",
        "Jordan",
        "Japan",
        "Kenya",
        "Kyrgyzstan",
        "Cambodia",
        "Kiribati",
        "Comoros",
        "SaintKittsandNevis",
        "DemocraticPeople\u0027sRepublicofKorea",
        "RepublicofKorea",
        "Kuwait",
        "CaymanIslands",
        "Kazakhstan",
        "LaoPeople\u0027sDemocraticRepublic",
        "Lebanon",
        "SaintLucia",
        "SaintMartin",
        "Liechtenstein",
        "SriLanka",
        "Liberia",
        "Lesotho",
        "Lithuania",
        "Luxembourg",
        "Latvia",
        "LibyanArabJamahiriya",
        "Morocco",
        "Monaco",
        "RepublicofMoldova",
        "Montenegro",
        "Madagascar",
        "MarshallIslands",
        "TheFormerYugoslavRepublicofMacedonia",
        "Mali",
        "Myanmar",
        "Mongolia",
        "NorthernMarianaIslands",
        "Martinique",
        "Mauritania",
        "Montserrat",
        "Malta",
        "Mauritius",
        "Maldives",
        "Malawi",
        "Mexico",
        "Malaysia",
        "Mozambique",
        "Namibia",
        "NewCaledonia",
        "Niger",
        "NorfolkIsland",
        "Nigeria",
        "Nicaragua",
        "Netherlands",
        "Norway",
        "Nepal",
        "Nauru",
        "Niue",
        "NewZealand",
        "Oman",
        "Panama",
        "Peru",
        "FrenchPolynesia",
        "PapuaNewGuinea",
        "Philippines",
        "Pakistan",
        "Poland",
        "PierreandMiquelonSaint",
        "PuertoRico",
        "OccupiedPalestinianTerritory",
        "Portugal",
        "Palau",
        "Paraguay",
        "Qatar",
        "Reunion",
        "Romania",
        "Serbia",
        "RussianFederation",
        "Rwanda",
        "SaudiArabia",
        "SolomonIslands",
        "Seychelles",
        "Sudan",
        "Sweden",
        "Singapore",
        "Slovenia",
        "SvalbardandJanMayen",
        "Slovakia",
        "SierraLeone",
        "SanMarino",
        "Senegal",
        "Somalia",
        "Suriname",
        "SaoTomeandPrincipe",
        "ElSalvador",
        "SyrianArabRepublic",
        "Swaziland",
        "TurksandCaicosIslands",
        "Chad",
        "Togo",
        "Thailand",
        "Tajikistan",
        "Tokelau",
        "LesteTimor",
        "Turkmenistan",
        "Tunisia",
        "Tonga",
        "Turkey",
        "TrinidadandTobago",
        "Tuvalu",
        "UnitedRepublicOfTanzania",
        "Ukraine",
        "Uganda",
        "UnitedStates",
        "Uruguay",
        "Uzbekistan",
        "HolySee(VaticanCityState)",
        "SaintVincentandtheGrenadines",
        "Venezuela",
        "BritishVirginIslands",
        "U.S.VirginIslands",
        "Vietnam",
        "Vanuatu",
        "WallisandFutunaIslands",
        "Samoa",
        "Yemen",
        "Mayotte",
        "SouthAfrica",
        "Zambia",
        "Zimbabwe",
        "Crimea"
    ]
};
const blockListResponse = {
    "safeZoneID": 0,
    "total": 0,
    "items": [],
};
const blockListSettingsResponse = {
    "safeZoneID": 0,
    "enabled": false,
};
 
export const worker = setupWorker(...[

    // GET REQUESTS
    //

    // USER
    //
    http.get(`${baseUrl}/user/whoami`, () => {
        return HttpResponse.json(whoamiResponse);
    }),
    http.get(`${baseUrl}/user/custom-logo`, () => {
        return HttpResponse.error();
    }),
    http.get(`${baseUrl}/content/terms/status`, () => {
        return HttpResponse.json([]);
    }),

    // ZONES
    //
    http.get(`${baseUrl}/ddos/v2/zones`, () => {
        return HttpResponse.json(zonesResponse);
    }),
    http.get(`${baseUrl}/ddos/v2/zones/null`, () => {
        return HttpResponse.error();
    }),
    http.get(`${baseUrl}/ddos/v2/zones/:id`, ({ params }) => {
        const { id } = params;
        return HttpResponse.json(zones[id]);
    }),
    http.get(`${baseUrl}/ddos/v2/zones/:id/filters`, ({ params }) => {
        const { id } = params;
        let zoneFilters = [];
        for (const filterIndex of zones[id]['filters'] ?? []) {
            zoneFilters.push(filters[filterIndex]);
        }
        let zoneFiltersResponse = {
            "page": 1,
            "pageSize": 10,
            "total": zoneFilters.length,
            "items": zoneFilters,
        };
        return HttpResponse.json(zoneFiltersResponse);
    }),
    http.get(`${baseUrl}/ddos/v2/zones/:id/geo-restrictions`, ({ params }) => {
        const { id } = params;
        let zoneRestrictions = [];
        for (const restrictionIndex of zones[id]['geoRestrictions'] ?? []) {
            zoneRestrictions.push(geoRestrictions[restrictionIndex]);
        }
        const geoRestrictionsResponse = {
            "page": 1,
            "pageSize": 10,
            "total": zoneRestrictions.length,
            "items": zoneRestrictions,
        };
        return HttpResponse.json(geoRestrictionsResponse);
    }),
    http.get(`${baseUrl}/ddos/v2/zones/:id/policy/1/zone-filter-drop-rate`, ({ params }) => {
        const { id } = params;
        let filterDropRateResponse = {
            "threshold": zones[id]['dropRate'],
            "deviceID": 1,
            "safeZoneID": id,
        };
        return HttpResponse.json(filterDropRateResponse);
    }),
    http.get(`${baseUrl}/ddos/v2/zones/:id/allowlist`, ({ params }) => {
        const { id } = params;
        let zoneList = [];
        for (const some of zones[id]['allowList'] ?? []) {
            zoneList.push(allowDenyList[some]);
        }
        const allowListResponse = {
            "maxIps": 0,
            "ips": zoneList,
        };
        return HttpResponse.json(allowListResponse);
    }),
    http.get(`${baseUrl}/ddos/v2/zones/:id/denylist`, ({ params }) => {
        const { id } = params;
        let zoneList = [];
        for (const ipIndex of zones[id]['denyList'] ?? []) {
            zoneList.push(allowDenyList[ipIndex]); 
        }
        const denyListResponse = {
            "maxIps": 0,
            "ips": zoneList,
        };
        return HttpResponse.json(denyListResponse);
    }),
    http.get(`${baseUrl}/ddos/v2/zones/:id/policy`, ({ params }) => {
        const { id } = params;
        return HttpResponse.json(zones[id]['policy']);
    }),
    http.get(`${baseUrl}/ddos/v2/zones/:id/dynamic-block-list`, ({ params }) => {
        const { id } = params;
        blockListResponse.safeZoneID = id;
        return HttpResponse.json(blockListResponse);
    }),
    http.get(`${baseUrl}/ddos/v2/zones/:id/dynamic-block-list/settings`, ({ params }) => {
        const { id } = params;
        blockListSettingsResponse.safeZoneID = id;
        blockListSettingsResponse.enabled = zones[id]['blockList'];
        return HttpResponse.json(blockListSettingsResponse);
    }),

    // METRICS
    //
    http.get(`${baseUrl}/ddos/v2/metrics/traffic`, ({ request }) => {
        // Calulate time difference in hours
        const startDate = new URL(request.url).searchParams.get('startDate');
        const endDate = new URL(request.url).searchParams.get('endDate');
        const differenceHours = Math.ceil(Math.abs(new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60));
        // Return only the last few entries
        const lastEntries = Object.entries(trafficResponse).slice(-6 * differenceHours - 1);
        let response = {}; for (const entry of lastEntries) {response[entry[0]] = entry[1];}
        return HttpResponse.json(response);
    }),
    http.get(`${baseUrl}/ddos/v2/zones/:id/metrics/traffic`, ({ request }) => {
        // Calulate time difference in hours
        const startDate = new URL(request.url).searchParams.get('startDate');
        const endDate = new URL(request.url).searchParams.get('endDate');
        const differenceHours = Math.ceil(Math.abs(new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60));
        // Return only the last few entries
        const lastEntries = Object.entries(trafficResponse).slice(-6 * differenceHours - 1);
        let response = {}; for (const entry of lastEntries) {response[entry[0]] = entry[1];}
        return HttpResponse.json(response);
    }),
    http.get(`${baseUrl}/ddos/v2/zones/:id/metrics/traffic/types`, ({ request }) => {
        // Calulate time difference in hours
        const startDate = new URL(request.url).searchParams.get('startDate');
        const endDate = new URL(request.url).searchParams.get('endDate');
        const differenceHours = Math.ceil(Math.abs(new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60));
        // Return only the last few entries
        const lastEntries = Object.entries(trafficTypesResponse).slice(-6 * differenceHours - 1);
        let response = {}; for (const entry of lastEntries) {response[entry[0]] = entry[1];}
        return HttpResponse.json(response);
    }),
    http.get(`${baseUrl}/ddos/v2/zones/:id/metrics/attacks`, ({ params }) => {
        return HttpResponse.json(attacksResponse);
    }),

    // DDOS GENERAL
    //
    http.get(`${baseUrl}/ddos/v2/filters`, () => {
        return HttpResponse.json(filtersResponse);
    }),
    http.get(`${baseUrl}/ddos/v2/filters/:id`, ({ params }) => {
        const { id } = params;
        return HttpResponse.json(filters[id]);
    }),
    http.get(`${baseUrl}/ddos/v2/packages/limits`, () => {
        return HttpResponse.json(limitsResponse);
    }),
    http.get(`${baseUrl}/pack-man/product/ddosv2`, () => {
        return HttpResponse.json(ddosv2Response);
    }),
    http.get(`${baseUrl}/pack-man/product/ddosv2/default`, () => {
        return HttpResponse.json(ddosv2Response);
    }),
    http.get(`${baseUrl}/ddos/v2/subnets`, () => {
        return HttpResponse.json(subnets);
    }),
    http.get(`${baseUrl}/ddos/v2/geo-restrictions/locations`, () => {
        return HttpResponse.json(locationsResponse);
    }),
    http.get(`${baseUrl}/ddos/v2/templates`, () => {
        return HttpResponse.json(templatesResponse);
    }),

    // POST REQUESTS
    //
    http.post(`${baseUrl}/ddos/v2/zones`, async ({ request }) => {
        let requestBody = await new Response(request.body).json();
        let newZone = {
            "id": zones.length,
            "name": requestBody.name,
            "description": requestBody.description,
            "createdAt": new Date().toISOString(),
            "currentAttacks": 0,
            "currentState": "active",
            "ips": requestBody.ips,
            "filters": [],
            "dropRate": 100,
            "geoRestrictions": [],
            "allowList": [],
            "denyList": [],
            "policy": {...policyResponse},
            "blockList": false,
        };
        // Add zone to zones list, update localStorage
        zones.push(newZone);
        localStorage.setItem('zones', JSON.stringify(zones));
        return HttpResponse.json();
    }),
    http.post(`${baseUrl}/ddos/v2/filters`, async ({ request }) => {
        let requestBody = await new Response(request.body).json();
        let newFilter = {
            "id": filters.length,
            "action": requestBody.action,
            "name": requestBody.name,
            "protocol": requestBody.protocol,
            "settings": requestBody.settings,
        };
        // Add filter to filters list, update localStorage
        filters.push(newFilter);
        localStorage.setItem('filters', JSON.stringify(filters));
        return HttpResponse.json();
    }),
    http.post(`${baseUrl}/ddos/v2/zones/:id/ip`, async ({ request, params }) => {
        const { id } = params;
        let requestBody = await new Response(request.body).json();
        // Add ip to zones ips and subnets, update localStorage
        zones[id]['ips'] ??= [];
        zones[id]['ips'].push(requestBody.ip);
        subnets.push(requestBody.ip);
        localStorage.setItem('zones', JSON.stringify(zones));
        localStorage.setItem('subnets', JSON.stringify(subnets));
        return HttpResponse.json();
    }),
    http.post(`${baseUrl}/ddos/v2/zones/:zoneId/filters/:filterId`, async ({ params }) => {
        const { zoneId, filterId } = params;
        // Add filter id to zones list, update localStorage
        zones[zoneId]['filters'] ??= [];
        zones[zoneId]['filters'].push(filterId);
        localStorage.setItem('zones', JSON.stringify(zones));
        return HttpResponse.json();
    }),
    http.post(`${baseUrl}/ddos/v2/zones/:id/geo-restrictions`, async ({ request, params }) => {
        const { id } = params;
        let requestBody = await new Response(request.body).json();
        let newRestriction = {
            "location": requestBody.location,
            "action": requestBody.action,
            "threshold": requestBody.threshold,
            "zoneId": id,
        };
        // Add restriction id to geoRestrictions and zones, update localStorage
        zones[id]['geoRestrictions'] ??= [];
        zones[id]['geoRestrictions'].push(geoRestrictions.length);
        geoRestrictions.push(newRestriction);
        localStorage.setItem('zones', JSON.stringify(zones));
        localStorage.setItem('geoRestrictions', JSON.stringify(geoRestrictions));
        return HttpResponse.json();
    }),
    http.post(`${baseUrl}/ddos/v2/zones/:id/allowlist`, async ({ request, params }) => {
        const { id } = params;
        let requestBody = await new Response(request.body).json();
        // Update allowdenylist and zone details, update localStorage
        zones[id]['allowList'] ??= [];
        zones[id]['allowList'].push(allowDenyList.length);
        allowDenyList.push(requestBody.ip);
        localStorage.setItem('allowDenyList', JSON.stringify(allowDenyList));
        localStorage.setItem('zones', JSON.stringify(zones));
        return HttpResponse.json();
    }),
    http.post(`${baseUrl}/ddos/v2/zones/:id/denylist`, async ({ request, params }) => {
        const { id } = params;
        let requestBody = await new Response(request.body).json();
        // Update allowdenylist and zone details, update localStorage
        zones[id]['denyList'] ??= [];
        zones[id]['denyList'].push(allowDenyList.length);
        allowDenyList.push(requestBody.ip);
        localStorage.setItem('allowDenyList', JSON.stringify(allowDenyList));
        localStorage.setItem('zones', JSON.stringify(zones));
        return HttpResponse.json();
    }),
    http.post(`${baseUrl}/ddos/v2/zones/:id/templates`, () => {
        return HttpResponse.json(templatesResponse);
    }),

    // PUT REQUESTS
    //
    http.put(`${baseUrl}/ddos/v2/filters/:id`, async ({ request, params }) => {
        const { id } = params;
        let requestBody = await new Response(request.body).json();
        // Update filter details, update localStorage
        filters[id]['action'] = requestBody.action;
        filters[id]['name'] = requestBody.name;
        filters[id]['protocol'] = requestBody.protocol;
        filters[id]['settings'] = requestBody.settings;
        localStorage.setItem('filters', JSON.stringify(filters));
        return HttpResponse.json();
    }),
    http.put(`${baseUrl}/ddos/v2/zones/:id/policy/1/zone-filter-drop-rate`, async ({ request, params }) => {
        const { id } = params;
        let requestBody = await new Response(request.body).json();
        // Update zone details, update localStorage
        zones[id]['dropRate'] = requestBody.threshold;
        localStorage.setItem('zones', JSON.stringify(zones));
        return HttpResponse.json();
    }),
    http.put(`${baseUrl}/ddos/v2/zones/:id/geo-restrictions/:location`, async ({ request, params }) => {
        const { id, location } = params;
        let requestBody = await new Response(request.body).json();
        // Update restriction details, update localStorage
        let newRestrictions = [];
        for (const restriction of geoRestrictions) {
            if (restriction.zoneId === id && restriction.location === location) {
                restriction.action = requestBody.action;
                restriction.threshold = requestBody.threshold;
            }
            newRestrictions.push(restriction);
        }
        geoRestrictions = newRestrictions;
        localStorage.setItem('geoRestrictions', JSON.stringify(geoRestrictions));
        return HttpResponse.json();
    }),
    http.put(`${baseUrl}/ddos/v2/zones/:id/policy`, async ({ request, params }) => {
        const { id } = params;
        let requestBody = await new Response(request.body).json();
        // Update zone policy, update localStorage
        zones[id]['policy'] = {...requestBody, zoneId: id};
        localStorage.setItem('zones', JSON.stringify(zones));
        return HttpResponse.json();
    }),
    http.put(`${baseUrl}/ddos/v2/zones/:id/dynamic-block-list/settings`, async ({ request, params }) => {
        const { id } = params;
        let requestBody = await new Response(request.body).json();
        // Update zone blocklist setting, update localStorage
        zones[id]['blockList'] = requestBody.enabled;
        localStorage.setItem('zones', JSON.stringify(zones));
        return HttpResponse.json();
    }),

    // PATCH REQUESTS
    //
    http.patch(`${baseUrl}/ddos/v2/zones/:id`, async ({ request, params }) => {
        const { id } = params;
        let requestBody = await new Response(request.body).json();
        // Update zone details, update localStorage
        zones[id]['name'] = requestBody.name;
        zones[id]['description'] = requestBody.description;
        localStorage.setItem('zones', JSON.stringify(zones));
        return HttpResponse.json();
    }),

    // DELETE REQUESTS
    //
    http.delete(`${baseUrl}/ddos/v2/zones/:id`, async ({ params }) => {
        const { id } = params;
        // Remove zone from zones list, update localStorage
        zones.splice(id, 1);
        localStorage.setItem('zones', JSON.stringify(zones));
        return HttpResponse.json();
    }),
    http.delete(`${baseUrl}/ddos/v2/filters/:id`, async ({ params }) => {
        const { id } = params;
        // Remove filter from filters list, update localStorage
        filters.splice(id, 1);
        localStorage.setItem('filters', JSON.stringify(filters));
        return HttpResponse.json();
    }),
    http.delete(`${baseUrl}/ddos/v2/zones/:id/ip`, async ({ request, params }) => {
        const { id } = params;
        let requestBody = await new Response(request.body).json();
        // Remove ip from zones ips, update localStorage
        zones[id]['ips'].splice(zones[id]['ips'].indexOf(requestBody.ip), 1);
        localStorage.setItem('zones', JSON.stringify(zones));
        return HttpResponse.json();
    }),
    http.delete(`${baseUrl}/ddos/v2/zones/:zoneId/filters/:filterId`, async ({ params }) => {
        const { zoneId, filterId } = params;
        // Remove filter from zone
        zones[zoneId]['filters'] ??= [];
        zones[zoneId]['filters'].splice(zones[zoneId]['filters'].indexOf(filterId), 1);
        localStorage.setItem('zones', JSON.stringify(zones));
        return HttpResponse.json();
    }),
    http.delete(`${baseUrl}/ddos/v2/zones/:id/geo-restrictions/:location`, async ({ params }) => {
        const { id, location } = params;
        // Find index of location
        let index = null;
        for (const restriction of geoRestrictions) {
            if (restriction.zoneId === id && restriction.location === location) {
                index = geoRestrictions.indexOf(restriction);
            }
        }
        // Remove restriction from zone, update localStorage
        zones[id]['geoRestrictions'] ??= [];
        zones[id]['geoRestrictions'].splice(zones[id]['geoRestrictions'].indexOf(index), 1);
        localStorage.setItem('zones', JSON.stringify(zones));
        return HttpResponse.json();
    }),
    http.delete(`${baseUrl}/ddos/v2/zones/:id/allowlist`, async ({ request, params }) => {
        const { id } = params;
        let requestBody = await new Response(request.body).json();
        // Remove ip from zone, update localStorage
        zones[id]['allowList'] ??= [];
        zones[id]['allowList'].splice(allowDenyList.indexOf(requestBody.ip), 1);
        localStorage.setItem('zones', JSON.stringify(zones));
        return HttpResponse.json();
    }),
    http.delete(`${baseUrl}/ddos/v2/zones/:id/denylist`, async ({ request, params }) => {
        const { id } = params;
        let requestBody = await new Response(request.body).json();
        // Remove ip from zone, update localStorage
        zones[id]['denyList'] ??= [];
        zones[id]['denyList'].splice(allowDenyList.indexOf(requestBody.ip), 1);
        localStorage.setItem('zones', JSON.stringify(zones));
        return HttpResponse.json();
    }),

    // CATCH ALL OTHER REQUESTS
    //
    http.get(`${baseUrl}/*`, () => {
        return HttpResponse.error();
    }),
    http.post(`${baseUrl}/*`, () => {
        return HttpResponse.error();
    }),
    http.put(`${baseUrl}/*`, () => {
        return HttpResponse.error();
    }),
    http.patch(`${baseUrl}/*`, () => {
        return HttpResponse.error();
    }),
    http.delete(`${baseUrl}/*`, () => {
        return HttpResponse.error();
    }),
])